import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

/**
 * Body-only form surface (dialog create/edit or manage-embedded Details).
 * Default: submit + flat/borderless sections + footer.
 * Override `saveStrategy: 'patch'` for manage-like section cards + patch-on-blur (no footer).
 */
export const formSurface = {
  id: SurfaceType.Form,
  saveStrategy: 'submit',
  defaultFieldMode: 'edit',
  viewStatePersistence: 'none',
  sectionLayout: { columns: 1, maxWidth: null, sectionBorder: false, columnDivider: true },
  // Create dialogs hand their title bar to the Form so capability controls sit beside close.
  ownsDialogChrome: true,
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Form],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Form>;
